<template>
    <div class="tw-flex tw-items-center tw-justify-center tw-mt-2">
        {{ $t("auth.tokenLogin.title") }}
    </div>
</template>

<script>
export default {
    props: {
        userId: {
            type: String,
            default: "",
        },
        token: {
            type: String,
            default: "",
        },
    },
    created() {
        // impersonated sessions have a token only which can be
        // used directly and is issues by us
        if (!this.userId) {
            this.$router.push("/profile");
        } else {
            this.$store
                .dispatch("auth/performTokenAuth", {
                    payload: { userId: this.userId, token: this.token },
                })
                .catch(() => {
                    this.$router.push("/auth/login");
                });
        }
    },
};
</script>
